// TODO， 移到cms的颜色配置中去， @于衍
export const DASHBOARD_COLOR = {
  pieFill: "#191B23",
  pieInnerStroke: "#262938",
  pieOuterStroke: "#252733",
  registered: "#50A9A4",
  verified: "#457977",
  deposited: "#183F3D",
  transparent: "transparent",
  spot: "#F17E00",
  yield: "#AA5900",
  structured: "#6D4300",
  strategies: "#B79269",
  venture: "#844D12",
  cold: "#251606",
  cumulativePayout: "#D79B35",
  unsettledRevenue: "#9B6F24",
  desktop: "#50A9A4",
  mobile: "#F17E00",
  general: "#457977",
  trade: "#50A9A4",
  intelligence: "#F17E00",
  wallet: "#A55600",
  strategy: "#F17E00",
  history: "#663700",
  others: "#663700",
  aum: "#F17E00",
  subscriber: "#F17E00",
  session: "#F17E00",
  volume: "#F17E00",
  trader: "#F17E00",
  "spot aum": "#F17E00",
  buy: "#F17E00",
  sell: "#AA5900",
  "stable coin": "#F17E00",
  crypto: "#AA5900",
};

export const AUM_STATISTICS_TYPE = {
  DAILY: "DAILY",
  MONTHLY: "MONTHLY",
};

export const PLATFORM_STATISTICS_TYPE = {
  MONTHLY_TWELVE: "MONTHLY_TWELVE",
  MONTHLY_LATEST: "MONTHLY_LATEST",
};

export const PLATFORM_LABEL_TYPES = {
  visitors: "visitors",
  logins: "logins",
  sessions: "sessions",
};

export const PLATFORM_TYPES = ["desktop", "mobile"];
export const PLATFORM_LABELS = [
  PLATFORM_LABEL_TYPES.visitors,
  PLATFORM_LABEL_TYPES.logins,
  PLATFORM_LABEL_TYPES.sessions,
];

export const PLATFORM_DATA_LABELS = {
  [PLATFORM_LABEL_TYPES.visitors]: "uniqueVisitors",
  [PLATFORM_LABEL_TYPES.logins]: "logins",
  [PLATFORM_LABEL_TYPES.sessions]: "sessions",
};

export const RECENT_OPERATION_TYPE = {
  // 客户注册
  CUSTOMER_REGISTER: "customer register",
  // 客户登录
  CUSTOMER_LOGIN: "customer login",
  // 客户登出
  CUSTOMER_LOGOUT: "customer logout",
  // 交易申购
  VENTURE_SUBSCRIBE: "deal subscribe",
  // 交易赎回
  VENTURE_REDEEM: "deal redeem",
  // 基金认购
  FUND_SUBSCRIBE: "fund subscribe",
  // 基金赎回
  FUND_REDEEM: "fund redeem",
  // 股权赎回
  SHARES_TRANSFER: "shares transfer",
  // 下单
  PLACE_ORDER: "place order",
  // 撤单
  CANCEL_ORDER: "cancel order",
  // 定投理财申购
  INVESTMENT_SUBSCRIBE: "investment subscribe",
  // 定投理财赎回
  INVESTMENT_REDEEM: "investment redeem",
  // 用户添加银行卡
  ADD_BANK_CARD: "add bank card",
  // 用户提交kyc信息
  ADD_KYC_INFO: "add kyc info",
  // 用户修改kyc信息
  UPDATE_KYC_INFO: "update kyc info",
  // 法币充币
  FIAT_DEPOSIT: "fiat deposit",
  // 法币提币
  FIAT_WITHDRAW: "fiat withdraw",
  // 电子货币充币
  CRYPTO_DEPOSIT: "crypto deposit",
  // 电子货币提币
  CRYPTO_WITHDRAW: "crypto withdraw",
  // 双币下单
  DUAL_PLACE: "dual place",
  // 累计期权下单
  ACCUMULATOR_PLACE: "accumulator subscription",
  SNOWBALL_PLACE: "snowball subscription",
  // DEFAULT: "default"
};

export const AGENT_PLATFORM_TYPES = {
  WEB: "Desktop",
  IOS: "IOS",
  ANDROID: "ANDROID",
};

// total aum 接口返回属性列表
export const AUM_PROPERTY = ["spot", "yield", "structured", "fund", "venture"];

// cms页面展示type
export const AUM_LABEL_TYPES = ["Spot", "Yield", "Structured", "Fund", "Venture"];

// CMS 客户详情页，aum柱状图显示需要添加当月数据，当月数据从wallet/info接口获取，界面显示和接口返回字段对应关系
export const AUM_AMOUNT_DATA = {
  Spot: "spotAmount",
  Yield: "yieldAmount",
  Structured: "structuredAmount",
  Strategies: "strategyAmount",
  Funds: "fundAmount",
  Venture: "ventureAmount",
  Cold: "coldWalletAmount",
};

// cms product table筛选选项
export const filterOptions = [
  { value: "", label: "All" },
  { value: "Y", label: "Y" },
  { value: "N", label: "N" },
];

// cms session history展示类型
export const SESSION_HISTORY_TYPE = [
  "General",
  "Trade",
  "Intelligence",
  "Wallet",
  "Yield",
  "Venture",
  "Structured",
  "History",
  "Fund",
  "Others",
];
